module.exports = __webpack_public_path__ + "static/15-cb02f2e0591b5531e66de27ea18c3a78.png";